/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var MultiColumnComboVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboVisualModelExport, _super);
    function MultiColumnComboVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.j = 0;
        _this.b = null;
        _this.p = 0;
        _this._columnHeadersVisible = false;
        _this.au = null;
        _this.at = null;
        _this.k = 0;
        _this._dropDownButtonVisible = false;
        _this.q = 0;
        _this.aa = null;
        _this.c = null;
        _this.ad = null;
        _this.ae = null;
        _this.af = null;
        _this.v = 0;
        _this.ab = null;
        _this.ac = null;
        _this._actualLabelVisible = false;
        _this._actualNoMatchesFoundLabel = null;
        _this.d = null;
        _this.e = null;
        _this.ai = null;
        _this.aj = null;
        _this.ak = null;
        _this.w = 0;
        _this.ag = null;
        _this.ah = null;
        _this.al = null;
        _this._rowSeparatorsVisible = false;
        _this.f = null;
        _this.aq = null;
        _this.ar = null;
        _this.as = null;
        _this.x = 0;
        _this.ao = null;
        _this.ap = null;
        _this.g = null;
        _this.r = 0;
        _this.h = null;
        _this.s = 0;
        _this.t = 0;
        _this.u = 0;
        _this.an = null;
        _this.i = null;
        _this.y = null;
        return _this;
    }
    Object.defineProperty(MultiColumnComboVisualModelExport.prototype, "columnHeadersVisible", {
        get: function () {
            return this._columnHeadersVisible;
        },
        set: function (a) {
            this._columnHeadersVisible = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboVisualModelExport.prototype, "dropDownButtonVisible", {
        get: function () {
            return this._dropDownButtonVisible;
        },
        set: function (a) {
            this._dropDownButtonVisible = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboVisualModelExport.prototype, "actualLabelVisible", {
        get: function () {
            return this._actualLabelVisible;
        },
        set: function (a) {
            this._actualLabelVisible = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboVisualModelExport.prototype, "actualNoMatchesFoundLabel", {
        get: function () {
            return this._actualNoMatchesFoundLabel;
        },
        set: function (a) {
            this._actualNoMatchesFoundLabel = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboVisualModelExport.prototype, "rowSeparatorsVisible", {
        get: function () {
            return this._rowSeparatorsVisible;
        },
        set: function (a) {
            this._rowSeparatorsVisible = a;
        },
        enumerable: true,
        configurable: true
    });
    MultiColumnComboVisualModelExport.prototype.am = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("actualBackgroundColor : " + this.a.serialize() + ", ");
        a.l("actualBaseTheme : " + this.j + ", ");
        a.l("actualBorderColor : " + this.b.serialize() + ", ");
        a.l("actualBorderWidth : " + this.p + ", ");
        a.l("columnHeadersVisible : " + this.columnHeadersVisible + ", ");
        a.l("actualContentPadding : { left: " + this.au.c + ",top: " + this.au.e + ",right: " + this.au.d + ",bottom: " + this.au.b + "},");
        a.l("actualDensity : " + this.k + ", ");
        a.l("dropDownButtonVisible : " + this.dropDownButtonVisible + ", ");
        a.l("actualFocusUnderlineOpacity : " + this.q + ", ");
        a.l("label : \"" + this.aa + "\", ");
        a.l("actualLabelTextColor : " + this.c.serialize() + ", ");
        if (!stringIsNullOrEmpty(this.ad)) {
            a.l("labelFontStyle : \"" + this.ad + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ae)) {
            a.l("labelFontVariant : \"" + this.ae + "\", ");
        }
        if (!stringIsNullOrEmpty(this.af)) {
            a.l("labelFontWeight : \"" + this.af + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ab)) {
            a.l("labelFontFamily : \"" + this.ab + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ac)) {
            a.l("labelFontStretch : \"" + this.ac + "\", ");
        }
        if (!isNaN_(this.v)) {
            a.l("labelFontSize : " + this.v + ", ");
        }
        a.l("actualLabelVisible : " + this.actualLabelVisible + ", ");
        a.l("actualNoMatchesFoundLabel :\"" + this.actualNoMatchesFoundLabel + "\", ");
        a.l("actualNoMatchesFoundLabelBackgroundColor : " + this.d.serialize() + ", ");
        a.l("actualNoMatchesFoundLabelTextColor : " + this.e.serialize() + ", ");
        if (!stringIsNullOrEmpty(this.ai)) {
            a.l("noMatchesFoundLabelFontStyle : \"" + this.ai + "\", ");
        }
        if (!stringIsNullOrEmpty(this.aj)) {
            a.l("noMatchesFoundLabelFontVariant : \"" + this.aj + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ak)) {
            a.l("noMatchesFoundLabelFontWeight : \"" + this.ak + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ag)) {
            a.l("noMatchesFoundLabelFontFamily : \"" + this.ag + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ah)) {
            a.l("noMatchesFoundLabelFontStretch : \"" + this.ah + "\", ");
        }
        if (!isNaN_(this.w)) {
            a.l("noMatchesFoundLabelFontSize : " + this.w + ", ");
        }
        a.l("placeholder : \"" + this.al + "\", ");
        a.l("rowSeparatorsVisible : " + this.rowSeparatorsVisible + ", ");
        a.l("actualTextColor : " + this.f.serialize() + ", ");
        if (!stringIsNullOrEmpty(this.aq)) {
            a.l("textStyleFontStyle : \"" + this.aq + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ar)) {
            a.l("textStyleFontVariant : \"" + this.ar + "\", ");
        }
        if (!stringIsNullOrEmpty(this.as)) {
            a.l("textStyleFontWeight : \"" + this.as + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ao)) {
            a.l("textStyleFontFamily : \"" + this.ao + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ap)) {
            a.l("textStyleFontStretch : \"" + this.ap + "\", ");
        }
        if (!isNaN_(this.x)) {
            a.l("textStyleFontSize : " + this.x + ", ");
        }
        a.l("actualUnderlineColor : " + this.g.serialize() + ", ");
        a.l("actualUnderlineOpacity : " + this.r + ", ");
        a.l("actualUnderlineRippleColor : " + this.h.serialize() + ", ");
        a.l("actualUnderlineRippleOpacity : " + this.s + ", ");
        a.l("actualUnderlineRippleWidth : " + this.t + ", ");
        a.l("actualUnderlineWidth : " + this.u + ", ");
        a.l("text : \"" + this.an + "\", ");
        if (this.y != null) {
            a.l("value : \"" + this.y.toString() + "\", ");
        }
        a.l("Grid : " + this.i.av());
        a.l("}");
        return a.toString();
    };
    MultiColumnComboVisualModelExport.$t = markType(MultiColumnComboVisualModelExport, 'MultiColumnComboVisualModelExport');
    return MultiColumnComboVisualModelExport;
}(Base));
export { MultiColumnComboVisualModelExport };
//# sourceMappingURL=MultiColumnComboVisualModelExport.js.map
